import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import Socket = SocketIOClient.Socket;
import { environment } from '@env/environment';

@Injectable()
export class MultiplaySocketService {
  defaultInstance: Socket;
  routeInstances: {[route: string]: Socket} = {};
  listeners: any[] = [];
  details = {
    'connect timeout': 500,
    'reconnect': true,
    'reconnection delay': 500,
    'reopen delay': 500,
    'max reconnection attempts': 10,
    'transports': [/*'polling',*/ 'websocket'],
  };


  public joinGame(path: string, room: string, token?: string): Socket {
    let details = this.details;
    if (token) {
      details = Object.assign({}, this.details, {
        query: 'token=' + token,
        path: path,
      });
    } else {
      details = Object.assign({}, this.details, {
        path: path,
      });
    }
    this.routeInstances[room] = io.connect(
      `wss://${environment.multiplayServer}${room}`, details
    );

    return this.routeInstances[room];
  }

  public leaveGame(room: string) {
    if (this.routeInstances.hasOwnProperty(room)) {
      this.routeInstances[room].disconnect();
    }
  }

  public connect(protocol: string, address: string, route: string, isDefault: boolean = false): void {
    const instance = io.connect(protocol + address + route, this.details);
    if (isDefault) {
      this.defaultInstance = instance;
    }
    this.routeInstances[route] = instance;
  }

  public disconnect(): void {
    this.defaultInstance.disconnect();
  }

  public emit(route: string, eventType: string, method?: any, params?: any): Observable<any> {
    return Observable.fromPromise(new Promise(((resolve, reject) => {
      let instance: Socket;
      if (!route.startsWith('/')) {
        instance = this.defaultInstance;
        params = method;
        method = eventType;
        eventType = route;
      } else {
        instance = this.routeInstances[route];
      }

      if (instance !== null && instance !== undefined) {
        if (params) {
          instance.emit(eventType, method, params, (result: any) => {
            resolve(result);
          });
        } else {
          instance.emit(eventType, method, (result: any) => {
            resolve(result);
          });
        }
      } else {
        reject(new Error('Socket has not been initiated.'));
      }
    })));
  }

  public listen(route: string, method: string): Observable<any> {
    return new Observable(observer => {
      let instance: Socket;
      if (!route.startsWith('/')) {
        instance = this.defaultInstance;
        method = route;
      } else {
        instance = this.routeInstances[route];
      }
      if (instance !== null) {
        this.listeners.push(method);
        instance.on(method, (result: any) => {
          observer.next(result);
        });
      }
      /*return () => {
        instance.disconnect();
      };*/
    });
  }

  public emitStream(route: string, eventType: string, stream: string, data?: any): Observable<any> {
    return Observable.fromPromise(new Promise(((resolve, reject) => {
      let instance: Socket;
      if (!route.startsWith('/')) {
        instance = this.defaultInstance;
        data = stream;
        stream = eventType;
        eventType = route;
      } else {
        instance = this.routeInstances[route];
      }

      if (instance !== null && instance !== undefined) {
        ss(instance).emit(eventType, stream, data, (result: any) => {
          resolve(result);
        });
      } else {
        reject(new Error('Socket has not been initiated.'));
      }
    })));
  }

  public removeListener(route: string, method: string): void {
    if (this.routeInstances[route]) {
      this.routeInstances[route].off(method);
    }
  }

  public unbindAll(): void {
    this.listeners.forEach((name) => {
      for (const route in this.routeInstances) {
        this.routeInstances[route].off(name);
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/multiplay-socket.service.ts